import React from 'react';
import ProductActionButtons from '../../ProductActionButtons';

const ProductListHeader = ({ 
  selectedCount, 
  onOpenModal, 
  onDeleteSelected 
}) => {
  return (
    <div className="flex items-center justify-between mb-5">
      <div>
        <div className="h-6 flex items-center px-2">
          {selectedCount > 0 && (
            <p className="text-s text-gray-800">
              {selectedCount}개 항목이 선택됨
            </p>
          )}
        </div>
      </div>
      <ProductActionButtons
        onOpenModal={onOpenModal}
        onDeleteSelected={onDeleteSelected}
        selectedCount={selectedCount}
      />
    </div>
  );
};

export default ProductListHeader;
